// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPGLoan,
  IsApplicantSameAsPrincipal,
  HasPgFiledTaxesYearsAgo,
} from '../rules';

class PgTaxes2YearsAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPGLoan = IsPGLoan.evaluate(data);
    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    ).evaluate(data);
    const hasPgNotFiledTaxes1YearAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(1)
      .setAnswer('No')
      .evaluate(data);

    const hasPgFiledTaxes2YearsAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(2)
      .setAnswer('Yes')
      .evaluate(data);

    const hasPGFiledTaxes2YearsAgoNotAnswered =
      HasPgFiledTaxesYearsAgo.setPrincipalId(this.principalId)
        .setYears(2)
        .setAnswer(null)
        .evaluate(data);

    return isPGLoan &&
      applicantSameAsPrincipal &&
      ((hasPgNotFiledTaxes1YearAgo && hasPgFiledTaxes2YearsAgo) ||
        (hasPgNotFiledTaxes1YearAgo && hasPGFiledTaxes2YearsAgoNotAnswered))
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PgTaxes2YearsAgoRuleset();
